<script>
	import { isInlineIcon } from '../types.js';
	import { getNewIcon } from '../../card_images.js'
	import OperationsSection from '../ops/OperationsSection.svelte';
	import OperationsSectionContent from '../ops/OperationsSectionContent.svelte';
	import { dbHover, dbUnhover, dbClick} from './dashfuncs';
    import { waiting, isTouchDevice, select, convert } from '../../ui.js';
	import { live, prefs, res, ui } from '../../stores.js';
    import { missionComplete } from '../../parse.js';
	import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css'; // optional for styling
    import MissionStatus from '../../MissionStatus.svelte';
    import MissionProgress from '../../MissionProgress.svelte';

	export let mission;
	export let isAdvanced;
	export let preview;
	export let p;
	let missElement, actionElement;
	let tip;

	$: vpLabel = `${mission.vp}vp`;

	function makeOpsStructure(text){
		// Based on Adam's helpers.ts parseOperation routine

		const split = text
			.split(/(Goal:|(?:Attack )?Reward:|Endgame:|Passive:)/)
			.filter((x) => x && x.length > 0);
		let opType = split[0].slice(0, -1).toLowerCase();
		const opText = split[1].trim();

		let isAttack = false;
		if (opType.startsWith('attack')) {
			isAttack = true;
			//console.log('is attack', text)
			opType = opType.split(' ')[1];
		}
		
		return {
			id: `${mission.deck}_${opType}_$[]`,
			type: opType,
			text: opText.charAt(0).toUpperCase() + opText.slice(1),
			isAttack
		}
	}

	function clickMission(e, m){
		if(preview) return;
		console.log('mission', m, $res.parsedCardText[m.id]);
		if($ui.selection != m){
            $ui.selection = m;
            $live.previewDashboard = p;
            $live.dashboardArea = 'mission';
        }else{
            $ui.selection = null;
            $live.previewDashboard = false;
        }
		e.stopPropagation();
	}

	$: if(!preview && $ui.selection && mission == $ui.selection){
        let i = p.dashboard.missions.findIndex(m => m == $ui.selection)
        //console.log('show', hide, $ui.selection, p.dashboard.missions, p.dashboard.missions.some(m => m == $ui.selection))
		if(missElement && !preview && !tip){
			tip = tippy(missElement, {
				content: actionElement,
				trigger: 'manual',
				interactive: true,
				appendTo: document.body,
				maxWidth: '50vw'
			})  
			if(tip) tip.show();
		}
        
    }else if(!$ui.selection || mission == $ui.selection){
        //console.log('hide', hide, $ui.selection,  p.dashboard.missions, p.dashboard.missions.some(m => m == $ui.selection))
        if(tip){
            tip.hide();
            tip.destroy();
            tip = null;
        }
    }
</script>

<div bind:this={missElement} class="mission {!isAdvanced ? 'center-y' : ''}"
	on:mouseenter={e => {dbHover(e, p, preview, 'mission')}}
	on:mousemove={e => {dbHover(e, p, preview, 'mission')}}
	on:mouseleave={e => {dbUnhover(e, p)}} 
	on:click={e => {if(!preview && !isTouchDevice()) clickMission(e, mission);}}
	on:touchstart={e => {if(!preview && isTouchDevice()) clickMission(e, mission);}}
>
	<MissionProgress {p} {mission} />
	<div class="mission-title font-heading">
		<span>{mission.name.toUpperCase()}</span>
		{#if isAdvanced && isInlineIcon(vpLabel)}
			<img src={getNewIcon(vpLabel)} />
		{/if}
	</div>
	<OperationsSection type="goal" let:labelColor let:textColor>
		<OperationsSectionContent operations={[makeOpsStructure(mission.goal)]} {labelColor} {textColor} />
	</OperationsSection>
	{#if mission.reward}
		<OperationsSection type="reward" let:labelColor let:textColor>
			<OperationsSectionContent operations={[makeOpsStructure(mission.reward)]} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
	{#if mission.table}
		<OperationsSection type="table" let:labelColor let:textColor>
			<OperationsSectionContent operations={mission.table} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
	{#if mission.endgame}
		<OperationsSection type="endgame" let:labelColor let:textColor>
			<OperationsSectionContent operations={[mission.endgame]} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
</div>
<div style="display: none;">
	<div bind:this={actionElement} class="mission_actions">
		{#if $ui.selection && mission == $ui.selection}
			<MissionStatus m={mission} status={mission.status}/><!--status={checkMission(p, $ui.selection)}/>-->
		{/if}
	</div>
</div>

<style lang="scss">
	.mission_actions {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
	.mission {
		flex-direction: column;
		flex-grow: 2;
		flex-basis: 0;
		max-width: 60%;
		gap: 0.4em;
		pointer-events: all;
		&.center-y {
			justify-content: center;
		}
		
	}
	.mission-title {
		color: azure;
		font-size: calc(var(--height) / 22.278); //18px;
		align-items: flex-start;
		justify-content: space-between;
		padding-right: 0.5em;
		& :global(img) {
			width: 1.3em;
			flex-shrink: 0;
		}
	}

	.container {
        position: relative;
        width: 100%;
    }

	.status {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
